import Api from '@/services/Api'

export default {
    getContabilizacionByFechaContab(fechaCantabilizacion){
        return Api().get('contratoContabilizacion/getContabilizacionByFechaContab/'+fechaCantabilizacion)
    },
    createContabilizacion(datos){
        return Api().post('contratoContabilizacion/create',datos)
    }
}